import { useEffect, useState } from "react";
import type { WhoAmI } from "@kontextwerk/web-common";
import { fetchMe } from "../lib/api";

/** Logged-in subject badge (ideas L83). Silent on error — never blocks the UI. */
export default function IdentityBadge() {
  const [me, setMe] = useState<WhoAmI | null>(null);

  useEffect(() => {
    fetchMe()
      .then(setMe)
      .catch(() => setMe(null));
  }, []);

  if (!me) return null;
  return (
    <span
      className="text-xs text-kw-text-muted truncate max-w-[16rem]"
      title={`${me.subject} · ${me.scopes.join(" ")}`}
    >
      <span className="text-kw-text-faint">subject</span> {me.subject}
    </span>
  );
}
